import { useMemo, useReducer } from "react"
import { useParams } from "react-router-dom"

import { multipleDateRangeReducer } from "helpers/reducers/dateRangeReducer"
import useDeviceGroups from "helpers/hooks/useDeviceGroups"
import AlertsContext from "widgets/alerts/AlertsContext"
import ActivityPanel from "widgets/alerts/ActivityPanel"
import AlertsTabView from "widgets/alerts/AlertsTabView"
import GroupAlertsContent from "widgets/deviceGroups/GroupAlertsContent"
import { BodyContainer } from "widgets/styled/containers"

function GroupAlerts() {
  const { id } = useParams()
  const { groups } = useDeviceGroups()
  const [multipleDateRange, dispatchMultipleDateRange] = useReducer(
    multipleDateRangeReducer,
    {},
  )

  const devicesIds = useMemo(() => {
    const group = groups?.find((g) => g.id === Number(id))
    return group?.device_list as number[] | undefined
  }, [groups, id])

  return (
    <AlertsContext.Provider
      value={{
        multipleDateRange,
        dispatchMultipleDateRange,
      }}
    >
      <BodyContainer disableGutters maxWidth="xl">
        <AlertsTabView
          tabsConfig={{
            configuredAlerts: <GroupAlertsContent />,
            activity: <ActivityPanel devicesIds={devicesIds} groupId={Number(id)} />,
          }}
        />
      </BodyContainer>
    </AlertsContext.Provider>
  )
}

export default GroupAlerts
